import {
  TYPE_CHECKLIST,
  TYPE_ORDERED_LIST,
  TYPE_UNORDERED_LIST
} from '../types';

export const isList = n =>
  [TYPE_ORDERED_LIST, TYPE_UNORDERED_LIST, TYPE_CHECKLIST].includes(n.type);
